<template>
    <v-row class="no-frame">
        <v-col class="no-frame v-col-3">
            <v-btn
                class    = "w-100 rating-button"
                :height  = "btnHeight"
                :class   = "yesClass"
                :ripple  = "false"
                :elevation = "0"
                variant  = "outlined"
                @click   = "onYes"
            >
                Ja
            </v-btn>
        </v-col>

        <v-col class="no-frame v-col-3 pl-2">
            <v-btn
                v-if     = "showNo"
                class    = "w-100 rating-button"
                :height  = "btnHeight"
                :class   = "noClass"
                :ripple  = "false"
                :elevation = "0"
                variant  = "outlined"
                @click   = "onNo"
            >
                Nein
            </v-btn>
        </v-col>


        <v-col class="no-frame v-col-3 pl-2" v-if="inadequate" >
            <v-btn
                class    = "w-100 rating-button"
                :height  = "btnHeight"
                :class   = "inClass"
                :elevation = "0"
                variant  = "outlined"
                @click   = "onInadequate"
            >
                Unzulänglich
            </v-btn>
        </v-col>
        <v-col class="no-frame v-col-3 pl-2">
            <v-btn
                class    = "w-100 rating-button"
                :height  = "btnHeight"
                :class   = "naClass"
                :elevation = "0"
                variant  = "outlined"
                @click   = "onNotApplicable"
            >
                nicht zutreffend
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "PAuditRating",

    props: {
        value: {

        },

        showNo: {
            default: true,
        },

        inadequate: {

        }
    },

    data: () => ({
        rating   : null,
        btnHeight: 26,
    }),

    computed: {
        yesClass () {
            return this.rating === 1 ? 'success' : 'lm-border'
        },

        noClass () {
            return this.rating === 2 ? 'red white--text' : 'lm-border'
        },

        naClass () {
            return this.rating === 3 ? 'secondary' : 'lm-border'
        },

        inClass () {
            return this.rating === 4 ? 'orange' : 'lm-border'
        },
    },

    mounted() {
        this.rating = this.value ? this.value : null;
    },

    watch: {
        value () {
            this.rating = this.value;
        }
    },

    methods: {
        onYes () {
            this.rating = 1;
            this.$emit("input", this.rating);
        },

        onNo () {
            this.rating = 2;
            this.$emit("input", this.rating);
        },

        onInadequate () {
            this.rating = 4;
            this.$emit("input", this.rating);
        },

        onNotApplicable () {
            this.rating = 3;
            this.$emit("input", this.rating);
        }
    }
}
</script>

<style scoped>

.rating-button {
    text-transform: none;
    letter-spacing: unset;
    font-weight: 400!important;
    font-size: 14px;
    border-radius: 4px;
    padding-top: 0;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 110px;
}

:deep(.v-btn--size-default) {
    min-width: 52px;
}

</style>